import { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { validateUpdatePasswordFields } from '../../../../Validation/Authentication/UpdatePassword';
import { MetaActionCreators } from '../../../../Store/ActionCreators/MetaActionCreators';
import { mapUpdatePasswordPostRequestValues } from '../../../../BusinessLogic/Handlers/Authentication';

class UpdatePasswordFormContainer extends Component {
    state = {
        password: '',
        passwordConfirmation: '',
        validationErrors: {},
    };

    handleInputChange = event => this.setState({ [event.target.name]: event.target.value });
    clearValidationErrors = () => this.setState({ validationErrors: {} });
    setValidationErrors = validationErrors => this.setState({ validationErrors });
    checkButonDisabled = () => this.state.password === '' || this.state.passwordConfirmation === '';

    handleSubmit = event => {
        event.preventDefault();

        this.clearValidationErrors();
        const { validationErrors, ...fields } = this.state;
        const { errors, isValidationPassed } = validateUpdatePasswordFields(fields);

        if (isValidationPassed)
            this.props.updatePassword(
                mapUpdatePasswordPostRequestValues({ password: this.state.password }),
                this.props.token,
            );
        else this.setValidationErrors(errors);
    };

    render() {
        return this.props.renderForm({
            ...this.state,
            handleChange: this.handleInputChange,
            handleSubmit: this.handleSubmit,
            isSubmitButtonDisabled: this.checkButonDisabled(),
        });
    }
}

UpdatePasswordFormContainer.defaultProps = {
    token: '',
};

UpdatePasswordFormContainer.propTypes = {
    token: PropTypes.string.isRequired,
};

const mapStateToProps = ({ meta }) => ({ token: meta.token });
const mapDispatchToProps = dispatch => ({
    updatePassword: (password, token) => dispatch(MetaActionCreators.setPassword(password, token)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(UpdatePasswordFormContainer);



// WEBPACK FOOTER //
// ./src/UI/Containers/FormContainers/Authentication/UpdatePasswordForm.js